export { default, ManifestationList } from './ManifestationList';



// WEBPACK FOOTER //
// ./app/components/search/ManifestationList/index.js